import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogPosts, generate2000WordContent } from '../data/blogData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiClock, FiCalendar, FiShare2 } = FiIcons;

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) return <div className="pt-40 text-center text-white">Post no encontrado.</div>;

  const fullContent = generate2000WordContent(post.keyword);

  return (
    <article className="pt-32 pb-20 px-4 bg-black text-white min-h-screen">
      <Helmet>
        <title>{post.title} | Online Classes English</title>
        <meta name="description" content={post.excerpt} />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        <Link to="/blog" className="inline-flex items-center gap-2 text-yellow-500 hover:text-white mb-8 transition-colors uppercase text-xs font-black tracking-widest">
          <FiArrowLeft /> Volver al Blog
        </Link>

        <header className="mb-12">
          <div className="flex items-center gap-4 text-[10px] font-black uppercase tracking-widest text-gray-500 mb-6">
            <span className="bg-red-600 text-white px-3 py-1 rounded-full">{post.category}</span>
            <span className="flex items-center gap-1"><FiCalendar /> {post.date}</span>
            <span className="flex items-center gap-1"><FiClock /> {post.readTime}</span>
          </div>
          <h1 className="text-4xl md:text-7xl font-black mb-8 leading-[0.9] tracking-tighter uppercase italic">
            {post.title}
          </h1>
          <p className="text-xl text-gray-400 italic border-l-4 border-yellow-500 pl-6">
            {post.excerpt}
          </p>
        </header>

        <div className="prose prose-invert max-w-none" dangerouslySetInnerHTML={{ __html: fullContent }} />

        <div className="mt-20 pt-10 border-t border-zinc-900 flex flex-col items-center text-center">
            <h3 className="text-2xl font-black uppercase italic mb-6">¿Te gustó este contenido?</h3>
            <div className="flex gap-4">
                <button className="flex items-center gap-2 bg-zinc-900 border border-zinc-800 px-6 py-3 rounded-xl font-bold hover:bg-zinc-800 transition-all">
                    <FiShare2 /> Compartir
                </button>
                <Link to="/shop" className="bg-yellow-500 text-black px-8 py-3 rounded-xl font-black uppercase text-sm shadow-xl">
                    Ver Catálogo 2026
                </Link>
            </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPost;